/**
 * REHBER360 - OTOMATİK HEDEF / FAALİYET KURALLARI
 *
 * Bu dosya motor değildir.
 * Yalnızca birebir isim eşleşmesinin yetmediği
 * doğrulanmış hedef → resmî faaliyet ilişkilerini tutar.
 *
 * relation:
 *
 * verified_equivalent
 *   Hedef ve faaliyet ifadeleri biçim / ifade farkına
 *   rağmen aynı veya doğrudan eşdeğer konuyu temsil eder.
 *
 * verified_related
 *   Faaliyet, hedefi doğrudan destekleyen güvenli bir
 *   resmî faaliyettir; isim eşdeğerliği iddia edilmez.
 *
 * ÖNEMLİ:
 * - Buradaki activityId'ler targetActivityCatalog'dan gelir.
 * - Serbest faaliyet adı üretilemez.
 * - needs_review kayıtları runtime'da kullanılmaz.
 */


export const AUTO_TARGET_ACTIVITY_RULES = {

  // =======================================================
  // 2026-2027 GENEL HEDEF
  // =======================================================

  selamlasma: {

    student: {
      activityIds: [
        "student_social_emotional_iletisim_becerileri"
      ],
      relation:
        "verified_related",
      evidence:
        "MEB_ORGM_2026_SELAMLASMA"
    },

    parent: {
      activityIds: [
        "parent_support_iletisim_becerileri"
      ],
      relation:
        "verified_related",
      evidence:
        "MEB_ORGM_2026_SELAMLASMA"
    },

    teacher: {
      activityIds: [
        "teacher_support_iletisim_becerileri"
      ],
      relation:
        "verified_related",
      evidence:
        "MEB_ORGM_2026_SELAMLASMA"
    }

  },

  akran_zorbaligi: {

    student: {
      activityIds: [
        "student_social_emotional_akran_zorbaligi"
      ],
      relation:
        "verified_related"
    },

    parent: {
      activityIds: [
        "parent_support_akran_zorbaligi"
      ],
      relation:
        "verified_related"
    },

    teacher: {
      activityIds: [
        "teacher_support_akran_zorbaligi"
      ],
      relation:
        "verified_related"
    }

  },


  // =======================================================
  // SOSYAL DUYGUSAL
  // =======================================================

  bagimlilikla_mucadele: {

    student: {

      relation:
        "verified_related",

      evidence:
        "REHBER360_CURATED_BY_LEVEL_V1",

      bySchoolLevel: {

        preschool: {
          activityIds: [
            "student_social_emotional_tbm_saglikli_yasam"
          ]
        },

        primary: {
          activityIds: [
            "student_social_emotional_teknoloji_bagimliligini_onleme"
          ]
        },

        middle_school: {
          activityIds: [
            "student_social_emotional_madde_bagimliligini_onleme"
          ]
        },

        high_school: {
          activityIds: [
            "student_social_emotional_madde_bagimliligini_onleme"
          ]
        },

        vocational_high_school: {
          activityIds: [
            "student_social_emotional_madde_bagimliligini_onleme"
          ]
        }

      }

    },


    parent: {

      relation:
        "verified_related",

      evidence:
        "REHBER360_CURATED_BY_LEVEL_V1",

      bySchoolLevel: {

        preschool: {
          activityIds: [
            "parent_support_tbm_saglikli_yasam"
          ]
        },

        primary: {
          activityIds: [
            "parent_support_tbm_teknoloji_bagimliligi"
          ]
        },

        middle_school: {
          activityIds: [
            "parent_support_madde_bagimliligini_onleme"
          ]
        },

        high_school: {
          activityIds: [
            "parent_support_madde_bagimliligini_onleme"
          ]
        },

        vocational_high_school: {
          activityIds: [
            "parent_support_madde_bagimliligini_onleme"
          ]
        }

      }

    },


    teacher: {

      relation:
        "verified_related",

      evidence:
        "REHBER360_CURATED_BY_LEVEL_V1",

      bySchoolLevel: {

        preschool: {
          activityIds: [
            "teacher_support_tbm_saglikli_yasam"
          ]
        },

        primary: {
          activityIds: [
            "teacher_support_teknoloji_bagimliligini_onleme"
          ]
        },

        middle_school: {
          activityIds: [
            "teacher_support_madde_bagimliligini_onleme"
          ]
        },

        high_school: {
          activityIds: [
            "teacher_support_madde_bagimliligini_onleme"
          ]
        },

        vocational_high_school: {
          activityIds: [
            "teacher_support_madde_bagimliligini_onleme"
          ]
        }

      }

    }

  },



  cinsel_egitim: {

    student: {
      activityIds: [
        "student_social_emotional_cocuklarda_cinsel_egitim"
      ],
      relation:
        "verified_equivalent"
    },

    parent: {
      activityIds: [
        "parent_support_cocuklarda_cinsel_egitim"
      ],
      relation:
        "verified_equivalent"
    },

    teacher: {
      activityIds: [
        "teacher_support_cocuklarda_cinsel_egitim"
      ],
      relation:
        "verified_equivalent"
    }

  },


  gelisim_donemi_ozellikleri: {

    parent: {
      activityIds: [
        "parent_support_cocuk_ve_ergenlerin_gelisim_donemleri"
      ],
      relation:
        "verified_related"
    }

  },


  hak_ve_sorumluluklarini_bilme: {

    parent: {
      activityIds: [
        "parent_support_cocuk_hak_ve_sorumluluklari"
      ],
      relation:
        "verified_related"
    },

    teacher: {
      activityIds: [
        "teacher_support_cocuk_hak_ve_sorumluluklari"
      ],
      relation:
        "verified_related"
    }

  },



  hayat_boyu_ogrenme: {

    student: {
      activityIds: [
        "student_social_emotional_yasam_becerileri"
      ],
      relation:
        "verified_related",
      evidence:
        "REHBER360_CURATED_V1"
    },

    parent: {
      activityIds: [
        "parent_support_oz_duzenlemeli_ogrenme"
      ],
      relation:
        "verified_related",
      evidence:
        "REHBER360_CURATED_V1"
    },

    teacher: {
      activityIds: [
        "teacher_support_oz_duzenlemeli_ogrenme"
      ],
      relation:
        "verified_related",
      evidence:
        "REHBER360_CURATED_V1"
    }

  },

   ihmal_istismardan_korunma: {

    student: {
      activityIds: [
        "student_social_emotional_ihmal_istismardan_korunma"
      ],
      relation:
        "verified_related"
    },

    parent: {
      activityIds: [
        "parent_support_ihmal_istismardan_korunma"
      ],
      relation:
        "verified_related"
    },

    teacher: {
      activityIds: [
        "teacher_support_ihmal_istismardan_korunma"
      ],
      relation:
        "verified_related"
    }

  },


  is_birligi_gelistirme: {

    student: {
      activityIds: [
        "student_social_emotional_isbirligi_gelistirme"
      ],
      relation:
        "verified_equivalent"
    },

    parent: {
      activityIds: [
        "parent_support_isbirligi_gelistirme"
      ],
      relation:
        "verified_equivalent"
    },

    teacher: {
      activityIds: [
        "teacher_support_isbirligi_gelistirme"
      ],
      relation:
        "verified_equivalent"
    }

  },


  ofke_yonetimi: {

    student: {
      activityIds: [
        "student_social_emotional_ofke_kontrolu"
      ],
      relation:
        "verified_related"
    }

  },


  ozfarkindaligi_gelistirme: {

    student: {
      activityIds: [
        "student_social_emotional_oz_farkindaligi_gelistirme"
      ],
      relation:
        "verified_equivalent"
    },

    parent: {
      activityIds: [
        "parent_support_oz_farkindaligi_gelistirme"
      ],
      relation:
        "verified_equivalent"
    },

    teacher: {
      activityIds: [
        "teacher_support_oz_farkindaligi_gelistirme"
      ],
      relation:
        "verified_equivalent"
    }

  },


  ozsaygi_gelistirme: {

    student: {
      activityIds: [
        "student_social_emotional_ozsaygi"
      ],
      relation:
        "verified_related"
    }

  },


  siddeti_onleme: {

    parent: {
      activityIds: [
        "parent_support_siddetin_onlenmesi"
      ],
      relation:
        "verified_equivalent"
    },

    teacher: {
      activityIds: [
        "teacher_support_siddetin_onlenmesi"
      ],
      relation:
        "verified_equivalent"
    }

  },


  stresle_bas_etme_becerileri: {

    parent: {
      activityIds: [
        "parent_support_stres_yonetimi"
      ],
      relation:
        "verified_equivalent"
    },

    teacher: {
      activityIds: [
        "teacher_support_stres_yonetimi"
      ],
      relation:
        "verified_equivalent"
    }

  },


  toplumsal_uyum_becerileri: {

    student: {
      activityIds: [
        "student_social_emotional_sosyal_beceriler"
      ],
      relation:
        "verified_related",
      evidence:
        "REHBER360_CURATED_V1"
    }

  },


  yaraticilik: {

    student: {
      activityIds: [
        "student_social_emotional_yaratici_dusunme_becerisi"
      ],
      relation:
        "verified_related"
    }

  },


  // =======================================================
  // AKADEMİK
  // =======================================================

  okul_basarisini_artirma: {

    parent: {
      activityIds: [
        "parent_support_okul_basarisinda_ailenin_rolu"
      ],
      relation:
        "verified_related"
    }

  },


   okul_ve_cevre_sosyokulturel_imkanlar: {

    student: {
      activityIds: [
        "student_academic_okulun_sosyokulturel_imk_nlari"
      ],
      relation:
        "verified_equivalent"
    },

    parent: {
      activityIds: [
        "parent_support_okula_uyum_calismalari"
      ],
      relation:
        "verified_related",
      evidence:
        "REHBER360_CURATED_V1"
    },

    teacher: {
      activityIds: [
        "teacher_support_okula_ve_cevreye_uyum"
      ],
      relation:
        "verified_related",
      evidence:
        "REHBER360_CURATED_V1"
    }

  },


  okula_ve_cevreye_uyum: {

    parent: {
      activityIds: [
        "parent_support_okula_uyum_calismalari"
      ],
      relation:
        "verified_related"
    }

  },


  okulda_secilecek_alan_dallar: {

    student: {
      activityIds: [
        "student_academic_okulda_secilebilecek_alan_dallar"
      ],
      relation:
        "verified_equivalent"
    },

    parent: {
      activityIds: [
        "parent_support_alan_dal_tanitimi_ve_secimi"
      ],
      relation:
        "verified_related"
    }

  },


  oz_disiplin_gelistirme: {

    parent: {
      activityIds: [
        "parent_support_cocuklarda_oz_disiplin_gelistirme"
      ],
      relation:
        "verified_related"
    }

  },


  ozduzenlemeli_ogrenme: {

    student: {
      activityIds: [
        "student_academic_oz_duzenlemeli_ogrenme"
      ],
      relation:
        "verified_equivalent"
    },

    parent: {
      activityIds: [
        "parent_support_oz_duzenlemeli_ogrenme"
      ],
      relation:
        "verified_equivalent"
    },

    teacher: {
      activityIds: [
        "teacher_support_oz_duzenlemeli_ogrenme"
      ],
      relation:
        "verified_equivalent"
    }

  },


  rpd_hizmetlerinin_tanitilmasi: {

    student: {
      activityIds: [
        "student_academic_rehberlik_ve_psk_dan_ser_tan"
      ],
      relation:
        "verified_equivalent"
    },

    parent: {
      activityIds: [
        "parent_support_rehberlik_ve_psk_danisma_servisinin_tanitilmasi"
      ],
      relation:
        "verified_equivalent"
    },

    teacher: {
      activityIds: [
        "teacher_support_rehberlik_ve_psk_danisma_servisinin_tanitilmasi"
      ],
      relation:
        "verified_equivalent"
    }

  },


  ust_ogrenim_kurumlarinin_tanitilmasi: {

    parent: {
      activityIds: [
        "parent_support_ust_ogrenim_kurumlari"
      ],
      relation:
        "verified_related"
    },

    teacher: {
      activityIds: [
        "teacher_support_ust_ogrenim_kurumlari"
      ],
      relation:
        "verified_related"
    }

  },


  // =======================================================
  // KARİYER
  // =======================================================

  is_ve_meslek_etigi: {

    parent: {
      activityIds: [
        "parent_support_etik_davranis"
      ],
      relation:
        "verified_related",
      evidence:
        "REHBER360_CURATED_V1"
    }

  },


    kariyer_gelisimi: {

    parent: {
      activityIds: [
        "parent_support_kariyer_planlama"
      ],
      relation:
        "verified_related",
      evidence:
        "REHBER360_CURATED_V1"
    }

  },


  meslek_secerken_dikkat_edilecek_hususlar: {

    teacher: {
      activityIds: [
        "teacher_support_meslek_secerken_dikkat_edilmesi_gerekenler"
      ],
      relation:
        "verified_equivalent"
    }

  },


  mesleki_benlik: {

    student: {
      activityIds: [
        "student_career_meslek_ile_ilgi_deger_yetenek_ve_kisisel_ozellik_iliskisi"
      ],
      relation:
        "verified_related",
      evidence:
        "REHBER360_CURATED_V1"
    },

    parent: {
      activityIds: [
        "parent_support_meslek_ile_ilgi_deger_yetenek_ve_kisisel_ozellik_iliskisi"
      ],
      relation:
        "verified_related",
      evidence:
        "REHBER360_CURATED_V1"
    },

    teacher: {
      activityIds: [
        "teacher_support_meslek_ile_ilgi_deger_yetenek_ve_kisisel_ozellik_iliskisi"
      ],
      relation:
        "verified_related",
      evidence:
        "REHBER360_CURATED_V1"
    }

  },

   mesleki_hedef_belirleme: {

    parent: {
      activityIds: [
        "parent_support_hedef_belirleme"
      ],
      relation:
        "verified_related",
      evidence:
        "REHBER360_CURATED_V1"
    },

    teacher: {
      activityIds: [
        "teacher_support_hedef_belirleme"
      ],
      relation:
        "verified_related",
      evidence:
        "REHBER360_CURATED_V1"
    }

  },



  meslek_ilgi_deger_yetenek_kisilik_iliskisi: {

    student: {
      activityIds: [
        "student_career_meslek_ile_ilgi_deger_yetenek_ve_kisisel_ozellik_iliskisi"
      ],
      relation:
        "verified_equivalent"
    },

    parent: {
      activityIds: [
        "parent_support_meslek_ile_ilgi_deger_yetenek_ve_kisisel_ozellik_iliskisi"
      ],
      relation:
        "verified_equivalent"
    },

    teacher: {
      activityIds: [
        "teacher_support_meslek_ile_ilgi_deger_yetenek_ve_kisisel_ozellik_iliskisi"
      ],
      relation:
        "verified_equivalent"
    }

  }

};


// =========================================================
// HELPERS
// =========================================================

export const getAutoTargetActivityRule = (
  targetId,
  audience,
  schoolLevel = null
) => {

  if (
    !targetId ||
    !audience
  ) {
    return null;
  }


  const baseRule =
    AUTO_TARGET_ACTIVITY_RULES
      ?.[targetId]
      ?.[audience] ||
    null;


  if (!baseRule) {
    return null;
  }


  /*
   * Normal kurallar tüm kademelerde kullanılabilir.
   *
   * Ancak Bağımlılıkla Mücadele gibi bazı geniş
   * hedeflerde okul kademesine göre farklı resmî
   * faaliyet seçebilmemiz gerekir.
   *
   * Şimdilik hiçbir mevcut kuralı değiştirmez;
   * yalnızca altyapıyı hazırlar.
   */
  const schoolLevelRule =
    schoolLevel
      ? baseRule
          ?.bySchoolLevel
          ?.[schoolLevel] ||
        null
      : null;


  if (!schoolLevelRule) {
    return baseRule;
  }


  return {
    ...baseRule,
    ...schoolLevelRule,

    /*
     * Kaynak yapı debug / audit için korunur.
     */
    bySchoolLevel:
      baseRule.bySchoolLevel
  };
};